import { AnimatePresence } from 'framer-motion'
import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import { getParams } from '@/utils/tool'

import router, { routerType } from './conf'
import CustomRouter from './CustomRouter'
import history from './history'

// 守卫
const RequireAuth = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  console.log('location', location)
  const { token, userId } = getParams(location.search)
  if ((token && !localStorage.token) || !localStorage.userid) {
    localStorage.token = token
  }
  if (userId && !localStorage.userid) {
    localStorage.userid = userId
  }
  const uid = localStorage.getItem('userid') || false
  const tokenCurrent = localStorage.token || false
  // 注意，如果路由中没有「/」的声明，一定要排除，不然Navigate受两次跳转会失效
  console.log('location.pathname', location.pathname)

  const filterPath = ['/login', '/screenRecordMark', '/screenRecordControl', '/room2']
  if (!filterPath.includes(location.pathname) && location.pathname !== '/' && (!uid || !tokenCurrent)) {
    return <Navigate to="/login" state={{ from: location }} replace />
  } else {
    return <>{children}</>
  }
}

// 循环
const RouterTree = (tree: routerType[]) => {
  return tree.map(({ path, component, children }) => {
    if (children && children.length) {
      return (
        <Route key={path} path={path} element={component}>
          {RouterTree(children)}
        </Route>
      )
    } else {
      return <Route key={path} path={path} element={<RequireAuth>{component}</RequireAuth>} />
    }
  })
}

// 动画
const AnimatedRoutes = () => {
  const location = useLocation()
  return (
    <AnimatePresence
      exitBeforeEnter
      initial={true}
      onExitComplete={() => {
        if (typeof window !== 'undefined') {
          window.scrollTo({ top: 0 })
        }
      }}
    >
      <Routes location={location} key={location.pathname}>
        {RouterTree(router)}
      </Routes>
    </AnimatePresence>
  )
}

export default function Index() {
  return (
    <CustomRouter history={history} basename={'/student'}>
      <AnimatedRoutes />
    </CustomRouter>
  )
}
